import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function FooterSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
  return <footer ref={ref} className="dark" style={{
    fontFamily: "'Playfair Display', serif"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=DM+Mono:wght@300;400&display=swap');`}</style>
      <section className="bg-background text-foreground">

        <div className={`transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
          <div className="max-w-6xl mx-auto px-6 pt-16 pb-0">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-0">

              <div className="md:col-span-7 border-border md:border-r pr-0 md:pr-16 pb-12 md:pb-16">
                <div className="flex items-start gap-4 mb-6">
                  <div className="mt-1 shrink-0">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                      <path d="M7 2v20" />
                      <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                    </svg>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold leading-tight tracking-tight text-foreground" style={{
                  fontFamily: "'Playfair Display', serif"
                }}>
                    About San Luis Tortillerias
                  </h2>
                </div>

                <div className="pl-0 md:pl-12">
                  <Separator className="mb-6 bg-primary opacity-40 h-px" />
                  <p className="text-muted-foreground text-lg leading-relaxed max-w-lg" style={{
                  fontFamily: "'DM Mono', monospace",
                  fontWeight: 300,
                  letterSpacing: "0.01em"
                }}>
                    Our small Mexican business has been selling traditional, homemade tortillas since 2005. Made with the finest ingredients and techniques, our tortillas are the perfect addition to any meal.
                  </p>
                </div>
              </div>

              <div className="md:col-span-5 md:pl-16 pb-12 md:pb-16 flex flex-col justify-start pt-0 md:pt-1">
                <h2 className="text-3xl md:text-4xl font-bold leading-tight tracking-tight text-foreground mb-6" style={{
                fontFamily: "'Playfair Display', serif"
              }}>
                  Opening Hours
                </h2>
                <Separator className="mb-8 bg-primary opacity-40 h-px" />

                <div className="flex flex-col gap-4">
                  <div className="flex items-stretch gap-0">
                    <div className="w-1.5 bg-primary rounded-full mr-6 shrink-0" />
                    <div className="flex flex-col gap-1">
                      <span className="text-foreground text-xl font-bold" style={{
                      fontFamily: "'Playfair Display', serif"
                    }}>
                        Monday - Sunday
                      </span>
                      <span className="text-primary text-2xl font-bold tracking-widest" style={{
                      fontFamily: "'DM Mono', monospace"
                    }}>
                        7AM - 9PM
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="border-t border-border bg-card">
            <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-muted-foreground text-sm tracking-wide" style={{
              fontFamily: "'DM Mono', monospace",
              fontWeight: 300
            }}>
                © 2023 Sanluistortilleria. All rights reserved.
              </p>
              <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-muted-foreground hover:text-primary hover:bg-accent transition-colors duration-200 text-xs tracking-widest uppercase" style={{
              fontFamily: "'DM Mono', monospace"
            }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <path d="m18 15-6-6-6 6" />
                </svg>
                Scroll to top
              </Button>
            </div>
          </div>

        </div>
      </section>
    </footer>;
}